import React, { useMemo, useState } from "react";
import CameraTile from "./CameraTile";
import CameraFocusDialog from "./CameraFocusDialog";

export const CameraGrid = ({ cameras = [], alerts = [] }) => {
  const [focus, setFocus] = useState(null);

  const alertByCamera = useMemo(() => {
    const m = {};
    for (const a of alerts) {
      if (a.status === "resolved") continue;
      if (!a.camera_id) continue;
      if (!m[a.camera_id]) m[a.camera_id] = a;
    }
    return m;
  }, [alerts]);

  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-border shrink-0">
        <div className="flex items-center gap-2">
          <span className="h-widget">Camera Matrix</span>
          <span className="font-mono text-[10px] text-muted-foreground">{cameras.length} feeds</span>
        </div>
        <span className="micro-label flex items-center">
          <span className="live-dot inline-block align-middle mr-1.5" /> live
        </span>
      </div>

      <div className="flex-1 overflow-auto p-2 min-h-0">
        <div
          className="grid gap-2"
          style={{ gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}
          data-testid="camera-grid"
        >
          {cameras.map((cam) => (
            <CameraTile
              key={cam.id}
              camera={cam}
              hasAlert={!!alertByCamera[cam.id]}
              onExpand={setFocus}
            />
          ))}
        </div>
      </div>

      <CameraFocusDialog
        camera={focus}
        alerts={alerts}
        onClose={() => setFocus(null)}
      />
    </div>
  );
};

export default CameraGrid;
